import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { DashboardWidgetEvent } from '@app/cp/shared/models/DashboardWidgetEvent';
import { DisplayTarget } from '@app/cp/shared/enums/DisplayTarget';
import { FactoryComponents } from '@app/cp/shared/enums/FactoryComponents';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { v_InvoiceBus2 } from '@app/cp/shared/models/v_InvoiceBus2';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { CreditMemoWidgetUser } from '@app/cp/shared/models/CreditMemoWidgetUser';

@Component({
    selector: 'cp-credit-memo-approvals',
    templateUrl: './credit-memo-approvals.component.html',
    styleUrls: ['./credit-memo-approvals.component.scss'],
    standalone: false
})
export class CreditMemoApprovalsGridComponent extends BaseGridComponent<v_InvoiceBus2, null> {

    public aggregates: any[] = [];
    public aggregateResults;

    searchParam: WidgetSearch;
    subscriptions: Subscription[] = [];
    creditMemoUser: CreditMemoWidgetUser;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.subscriptions.push(svc_dashboard.generalWidgetRefresh$.subscribe(
            refresh => {
                this.loaderState = true;
                this.getData();
            }));
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();

    loaderState: boolean = true;
    invoices: any;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    initialLoad: boolean = true;

    private subs_featureFlagSet: Subscription;
    featureFlagSet = {};

    ngOnInit() {
        this.initialLoad = false;
        //because the setup method relies on featureFlagSet to be available we need to ensure we have the values before we run it
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.setup(this.dataFilter);
        });
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_featureFlagSet);
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    getData() {
        this.loaderState = true;
        this.hideError();

        if (this.featureFlagSet["credit-memo-approval-widget-high-priority-changes-pt-2"]) {
            this.svc_dashboard.getDashboardCreditMemoApprovalsGridV2(this.searchParam).subscribe(data => {
                if (!data) {
                    this.handleNetworkError(null);
                } else {
                    this.invoices = data.resultList;

                    this.gridData = _.cloneDeep(data.resultList);
                    this.loaderState = false;
                }
            },
                error => this.handleNetworkError(error));

            this.svc_dashboard.getCreditMemoWidgetUser(this.globals.userId).subscribe(data => {
                this.creditMemoUser = data.result;
            });

        } else {
            this.svc_dashboard.getDashboardCreditMemoApprovalsGrid(this.searchParam).subscribe(data => {
                if (!data) {
                    this.handleNetworkError(null);
                } else {
                    this.invoices = data;

                    this.gridData = _.cloneDeep(data);
                    this.loaderState = false;
                }
            },
                error => this.handleNetworkError(error));
        }
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }
    details(detailData: v_InvoiceBus2) {
        let w_event: DashboardWidgetEvent = new DashboardWidgetEvent();
        w_event.id = detailData.invoiceId;
        w_event.displayTarget = DisplayTarget.window;
        w_event.factoryComponent = FactoryComponents.DQOI;
        this.svc_dashWidget.nextDashboardWidgetEvent(w_event);
    }

    showDetailsPopup(id: string, type: number) {
        this.svc_dashboard.openDQOIPopup(id, type);
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
            console.log(JSON.stringify(this.aggregateResults));
        }
    }
}
